import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import enums from '../enum';
import componentServices from '../componentServices';

import SalesJobs from './salesJobs';
import RetailLeads from './retailLeads';
import SalesPerformance from './salesPerformance';
import ContractorList from './contractorList';
import VendorList from './vendorList';
import { getModel, ModelCollection } from 'Scripts/store';

export const RetailJobsHeading = () => {
	const { securityContext, store } = componentServices;
	const routeState = componentServices.store.getIn(['viewState', 'routeState']);
	const currentEmployee = securityContext.getCurrentEmployee();
	const targetEmployee = routeState && routeState.employeeKey ? getModel({ store, collection: ModelCollection.employees, key: routeState.employeeKey }) : currentEmployee;

	return currentEmployee && targetEmployee && currentEmployee.key !== targetEmployee.key ? <h1>Salesperson • <span>{ targetEmployee.fullName }</span></h1> : <div className="logo" />;
};

class RetailHeader extends React.Component<any,any> {
	handleRouteClick (key, e) {
		e.preventDefault();
		componentServices.router.pushHistory(componentServices.router.replacePathSegmentAt(1, key, true), {});
	}

	render () {
		const items:JSX.Element[] = [];
		const buttons = [{
			path: 'leads',
			name: 'Manage Leads',
			test: () => componentServices.securityContext.currentUserHasFeature('retail-sales', 'manage-leads')
		}, {
			path: 'performance',
			name: 'Performance',
			test: () => componentServices.securityContext.currentUserHasFeature('retail-sales', 'manage-sales-performance')
		}, {
			path: 'jobs',
			name: 'Jobs'
		}, {
			path: 'contractors',
			name: 'Contractors',
			test: () => componentServices.securityContext.currentUserHasFeature('retail-sales', 'contractor-basic')
		}, {
			path: 'suppliers',
			name: 'Suppliers'
		}];

		_.forEach(_.filter(buttons, b => !b.test || b.test()), button => {
			let className = 'button';

			// TODO: deal with possible disabled status of header links
			className += (componentServices.router.isActive('retail-sales', button.path)) ? ' on' : '';

			// Note the new statusDot span to be placed inside the inner span of the button for the operations jobs button when there are new issues on the dashboard
			// items.push(<li key={button.path}><a onClick={this.handleRouteClick.bind(this, button.path)} className={className}><span><span className="statusDot"></span>{button.name}</span></a></li>);
			items.push(<li key={button.path}><a onClick={this.handleRouteClick.bind(this, button.path)} className={className}><span>{button.name}</span></a></li>);
		});

		return (
			<header>
				<ul className="menu">
					{ items }
				</ul>
			</header>
		);
	}
}

class RetailModule extends React.Component<any,any> {
	componentDidMount () {
		actions.setHeader({
			key: 'retailModuleHeader',
			element: (
				<RetailHeader key={'retailModuleHeader'} />
			)
		});
	}

	componentWillUnmount () {
		actions.deleteHeader({ key: 'retailModuleHeader' });
	}

	render () {
		const { children } = this.props;

		return children;
	}
}

componentServices.router.addRoutes([{
	path: '/retail-sales/leads',
	component: ({ ...props }) => <RetailModule { ...props}><RetailLeads { ...props} /></RetailModule>, // props are passed to the job because it is a PureComponent and not passing the store prevents re-render
	contentClass: 'jobDetail',
	onEnter: componentServices.router.requireUser(({ securityContext }) => securityContext.currentUserHasFeature('retail-sales', 'manage-leads'))
}, {
	path: '/retail-sales/performance',
	component: ({ ...props }) => <RetailModule { ...props}><SalesPerformance businessSegment={ enums.businessSegments.Retail } { ...props} /></RetailModule>, // props are passed to the job because it is a PureComponent and not passing the store prevents re-render
	contentClass: 'dashboard performance jobDetail',
	onEnter: componentServices.router.requireUser(({ securityContext }) => securityContext.currentUserHasFeature('retail-sales', 'manage-sales-performance'))
}, {
	path: '/retail-sales/jobs',
	component: ({ ...props }) => <RetailModule { ...props}><SalesJobs businessSegment={ enums.businessSegments.Retail } { ...props} /></RetailModule>, // props are passed to the job because it is a PureComponent and not passing the store prevents re-render
	contentClass: 'jobDetail',
	heading: <RetailJobsHeading />,
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('retail-sales'))
}, {
	path: '/retail-sales/contractors',
	contentClass: 'dashboard jobDetail',
	component: ({ ...props }) => {
		return <RetailModule { ...props}><ContractorList types={[enums.contractorTypes.Retail_Builder, enums.contractorTypes.Renovation_Contractor, enums.contractorTypes.Subtrade_Contractor, enums.contractorTypes.Delivery_Company]} moduleKey="retail-sales" /></RetailModule>;
	},
	onEnter: componentServices.router.requireUser(({ securityContext }) => securityContext.currentUserHasFeature('retail-sales', 'contractor-basic'))
}, {
	path: '/retail-sales/suppliers',
	contentClass: 'dashboard jobDetail',
	component: ({ ...props }) => {
		return <RetailModule { ...props}><VendorList types={[enums.vendorTypes.Cabinet_Supplier, enums.vendorTypes.Counter_Supplier, enums.vendorTypes.Outside_Supplier, enums.vendorTypes.Internal_Warehouse]} moduleKey="retail-sales" /></RetailModule>;
	}
}, {
	path: '/retail-sales',
	onEnter: ({ replace }) => {
		if (componentServices.securityContext.currentUserHasFeature('retail-sales', 'manage-leads')) {
			replace('/retail-sales/leads');
		}
		else {
			replace('/retail-sales/jobs');
		}

		// cancel the navigation
		return false;
	}
}]);

export default RetailModule;